export const getProfile = state => state.firebase.profile


// WEBPACK FOOTER //
// ./src/selectors/profile.selector.tsx